import {
  CatalogCategoryType,
  FilteredCategoryItemGroup,
} from '@/contexts/item-context-types';
import { useCatalogVariantPacksByGroupsList } from './use-catalog-variant-packs-by-groups-list';
import { useCatalogVariantPacksList } from './use-catalog-variant-packs-list';
import { useDynamicConfigValue } from './use-dynamic-config-value';

export interface Props {
  badgesFilter?: Set<string>;
  category?: CatalogCategoryType;
  selectedItemGroupCategory?: FilteredCategoryItemGroup | null;
  selectedSubcategoryUUIDs?: Set<string>;
}

export const useCatalogCategoryList = ({
  category,
  badgesFilter,
  selectedItemGroupCategory,
  selectedSubcategoryUUIDs,
}: Props) => {
  const itemGroupsEnabled = useDynamicConfigValue('item_groups_enabled');

  const categoryList = useCatalogVariantPacksList({ category });
  const variantPackGroupsList = useCatalogVariantPacksByGroupsList({
    badgesFilter,
    category,
    selectedItemGroupCategory,
    selectedSubcategoryUUIDs,
  });

  return itemGroupsEnabled ? variantPackGroupsList : categoryList;
};
